<p-card>
    <div class="">
         <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">
                <div>
                    <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" (click)="createAccount()"
                        size="small" pTooltip="Create Account"></p-button>
                    
                </div>
                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                            (keyup.enter)="searchAccounts()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchAccounts()" [ngStyle]="{ height: '35px' }" [raised]="true"
                        [size]="'small'" severity="info" class="ml-2"></p-button>
                </div>
                
                <p-button *ngIf="selectedAccount && selectedAccount.length == 1" label="Edit" class="ml-2"
                        icon="pi pi-pencil" (click)="editAccount()" size="small" severity="secondary"></p-button>
                    <p-button *ngIf="selectedAccount && selectedAccount.length > 0" label="Delete" class="ml-2"
                        icon="pi pi-trash" (click)="deleteAccount()" size="small" severity="danger"></p-button>
            </div>

                        <h2 class="page-title-center">General Ledger Accounts</h2>

            <div class="flex">
                <div class="flex align-items-center gap-2">
                    <p-button label="Recalculate GL Balances" icon="pi pi-calculator" size="small"
                        [outlined]="true" severity="help" (click)="recalculateGlBalances()"
                        [loading]="recalculateLoading"
                        pTooltip="Backfill opening/closing balance on all GL rows"></p-button>
                    <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>
            </div>
        </div>

        <p-table #dt1 [value]="result.account" [scrollable]="true" scrollHeight="500px" styleClass="p-datatable-striped"
            responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10" [totalRecords]="gridPagination.totalRecords"
            [globalFilterFields]="['accountCode']" [(selection)]="selectedAccount"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 15, 20]">


            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Account Code</th>
                    <th>Account Name</th>
                    <th>Account Type </th>
                    <th>Account Group </th>
                    <th>Financial Statement</th>
                    <th class="text-right">Closing Balance (₹)</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-Account>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="Account"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;"
                        (click)="editAccount(Account.accountsId)">{{Account.accountCode}}</td>
                    <td>{{Account.accountName}}</td>
                    <td>{{Account.accountTypes?.accountType}}</td>
                    <td>{{Account.accountGroup?.accountGroupName}}</td>
                    <td>{{Account.financialStatement}}</td>
                    <td class="text-right">{{ formatClosingBalance(Account.closingBalance) }}</td>                  
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>